export const actionTypes = {
  SET_AUTH: "SET_AUTH",
  SET_CONTROL_POPUP_MENU: "SET_CONTROL_POPUP_MENU",
  SET_DIMENSIONS: "SET_DIMENSIONS",
  SET_INGOGNITO: "SET_INGOGNITO",
  SET_LOADING: "SET_LOADING",
  SET_SCROLLTOP: "SET_SCROLLTOP",
  SET_SHOWNAVBAR: "SET_SHOWNAVBAR",
  SET_TITLEPOPUP: "SET_TITLEPOPUP",
  SET_TOOLTIP: "SET_TOOLTIP",
  SET_DEFAULT_TICKER: "SET_DEFAULT_TICKER",
};
